import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import {
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    FormGroup,
    Input,
    Label,
    Row,
} from "reactstrap";
import { MetaTags } from "react-meta-tags";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import {
    Breadcrumb_inputName,
    commonPageField,
    commonPageFieldSuccess,
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
    comAddPageFieldFunc,
    formValid,
    initialFiledFunc,
    onChangeText,
    resetFunction
} from "../../../components/Common/validationFunction";
import { SaveButton } from "../../../components/Common/CommonButton";
import {
    CommonConsole,
    metaTagLabel
} from "../../../components/Common/CommonFunction";
import { mode, url, pageId } from "../../../routes/index";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import { saveMsgUseEffect, userAccessUseEffect } from "../../../components/Common/CommonUseEffect";
import { globalTableSearchProps } from "../../../components/Common/SearchBox/MySearch";
import {
    editERPUrlIDSuccess,
    saveERPUrlMaster,
    saveERPUrlMaster_Success,
    updateERPUrlID,
    updateERPUrlIDSuccess,
    getERPUrlDetailsByMasterId_API,
    getERPUrlDetailsByMasterIdSuccess,
} from "../../../store/Utilites/ERPUrlRedux/action";

const PartyUrlInput = React.memo(
    ({ partyId, initialValue, onSave, registerInputRef, focusPartyInput }) => {
        const [value, setValue] = useState(initialValue || "");

        useEffect(() => {
            setValue(initialValue || "");
        }, [initialValue]);

        const handleChange = (e) => {
            setValue(e.target.value);
        };

        const handleBlur = () => {
            onSave(partyId, value);
        };

        const handleKeyDown = (e) => {
            if (e.key === "ArrowDown") {
                e.preventDefault();
                focusPartyInput(e.currentTarget, 1);
            }

            if (e.key === "ArrowUp") {
                e.preventDefault();
                focusPartyInput(e.currentTarget, -1);
            }
        };

        return (
            <Input
                innerRef={(input) => registerInputRef(partyId, input)}
                type="text"
                value={value}
                placeholder="Party-specific Url"
                onChange={handleChange}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
            />
        );
    }
);

const ERPUrl = (props) => {

    const history = useHistory()
    const dispatch = useDispatch();

    const fileds = {
        id: "",
        Name: "",
        Urls: "",
    }

    const [state, setState] = useState(() => initialFiledFunc(fileds))
    const [pageMode, setPageMode] = useState(mode.defaultsave);
    const [modalCss, setModalCss] = useState(false);
    const [userPageAccessState, setUserAccState] = useState('');
    const [editCreatedBy, seteditCreatedBy] = useState("");

    // ---------------------- party-wise url grid state ----------------------
    // One fixed row per party (from the shared party dropdown) — no add/remove.
    // { partyId, partyLabel, Urls }
    const [details, setDetails] = useState([]);
    const partyInputRefs = useRef(new Map());
    //Access redux store Data /  'save_ModuleSuccess' action data
    const {
        postMsg,
        updateMsg,
        pageField,
        saveBtnloading,
        userAccess,
        ERPUrlDetailsData,
        Distributor } = useSelector((state) => ({
            saveBtnloading: state.ERPUrlReducer.saveBtnloading,
            postMsg: state.ERPUrlReducer.postMsg,
            updateMsg: state.ERPUrlReducer.updateMsg,
            userAccess: state.Login.RoleAccessUpdateData,
            pageField: state.CommonPageFieldReducer.pageField,
            ERPUrlDetailsData: state.ERPUrlReducer.ERPUrlDetailsData,
            Distributor: state.CommonPartyDropdownReducer.commonPartyDropdownOption,
        }));

    const { values } = state
    const { isError } = state;
    const { fieldLabel } = state;

    // Recomputed only when the shared party list actually changes.
    const partyOptions = useMemo(
        () => (Distributor || []).map((p) => ({ value: p.id, label: p.Name })),
        [Distributor]
    );

    const location = { ...history.location }
    const hasShowloction = location.hasOwnProperty(mode.editValue)
    const hasShowModal = props.hasOwnProperty(mode.editValue)

    useEffect(() => {
        const page_Id = pageId.ERP_URL_M
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(page_Id))
    }, []);

    // Build one row per party — merge in the saved Url for that party (by
    // PartyId) whenever the party list or fetched detail data changes.
    // This is the only place `details` gets (re)populated.
    useEffect(() => {
        if (partyOptions.length === 0) return;

        const savedRows = ERPUrlDetailsData?.Data || [];
        const savedUrlByPartyId = new Map(
            savedRows.map((r) => [r.PartyId, r.Urls || ""])
        );

        setDetails(
            partyOptions.map((p) => ({
                partyId: p.value,
                partyLabel: p.label,
                Urls: savedUrlByPartyId.get(p.value) || "",
            }))
        );
    }, [partyOptions, ERPUrlDetailsData]);

    // userAccess useEffect
    useEffect(() => userAccessUseEffect({
        props,
        userAccess,
        dispatch,
        setUserAccState,
    }), [userAccess]);

    useEffect(() => {

        if ((hasShowloction || hasShowModal)) {

            let hasEditVal = null
            if (hasShowloction) {
                setPageMode(location.pageMode)
                hasEditVal = location.editValue
            }
            else if (hasShowModal) {
                hasEditVal = props.editValue
                setPageMode(props.pageMode)
                setModalCss(true)
            }

            if (hasEditVal) {
                const { id, Name, Urls, PartyDetails, CreatedBy } = hasEditVal[0]   // add PartyDetails + CreatedBy
                const { values, fieldLabel, hasValid, required, isError } = { ...state }
                values.id = id
                values.Name = Name;
                values.Urls = Urls;
                hasValid.Name.valid = true;
                hasValid.Urls.valid = true;
                setState({ values, fieldLabel, hasValid, required, isError })
                dispatch(Breadcrumb_inputName(Name))                 // was hasEditVal.Name
                seteditCreatedBy(CreatedBy)                          // was hasEditVal.CreatedBy
                dispatch(getERPUrlDetailsByMasterIdSuccess(PartyDetails || []))
            }
            dispatch(editERPUrlIDSuccess({ Status: false }))
        }
    }, [])


    useEffect(() => saveMsgUseEffect({
        postMsg, pageMode,
        history, dispatch,
        postSuccss: saveERPUrlMaster_Success,
        resetFunc: { fileds, state, setState },
        listPath: url.ERP_URL_L
    }), [postMsg])


    useEffect(() => {
        if (updateMsg.Status === true && updateMsg.StatusCode === 200 && !modalCss) {
            setState(() => resetFunction(fileds, state))// Clear form values
            history.push({
                pathname: url.ERP_URL_L,
            })
        } else if (updateMsg.Status === true && !modalCss) {
            dispatch(updateERPUrlIDSuccess({ Status: false }));
            customAlert({
                Type: 3,
                Message: JSON.stringify(updateMsg.Message),
            })
        }
    }, [updateMsg, modalCss]);


    useEffect(() => {
        if (pageField) {
            const fieldArr = pageField.PageFieldMaster
            comAddPageFieldFunc({ state, setState, fieldArr })
        }
    }, [pageField])


    // ---------------------- party-wise url grid handler ----------------------
    // Stable identity via useCallback (functional update, no `details` in
    // deps) so the column's onChange closure stays cheap to re-create.
    const handleDetailChange = useCallback((partyId, value) => {
        setDetails((prev) =>
            prev.map((row) =>
                row.partyId === partyId
                    ? { ...row, Urls: value }
                    : row
            )
        );
    }, []);

    const registerInputRef = useCallback((partyId, input) => {
        if (input) {
            partyInputRefs.current.set(partyId, input);
        } else {
            partyInputRefs.current.delete(partyId);
        }
    }, []);

    const focusPartyInput = useCallback((currentInput, direction) => {
        // Walk the table body in the order it's actually rendered on screen —
        // correct after sorting or search filtering, unlike iterating `details`.
        const table = currentInput.closest("table");
        if (!table) return;

        const inputs = Array.from(table.querySelectorAll("tbody tr td input"));
        const currentIndex = inputs.indexOf(currentInput);

        if (currentIndex === -1) return;

        const nextIndex = currentIndex + direction;
        if (nextIndex >= 0 && nextIndex < inputs.length) {
            inputs[nextIndex].focus();
        }
    }, []);

    // ---------------------- BootstrapTable columns ----------------------
    const partyUrlColumns = useMemo(
        () => [
            {
                dataField: "partyLabel",
                text: "Party",
                sort: true,
                headerStyle: () => ({ width: "35%" }),
            },
            {
                dataField: "Urls",
                text: "Url",
                formatter: (value, row) => (
                    <PartyUrlInput
                        partyId={row.partyId}
                        initialValue={row.Urls}
                        onSave={handleDetailChange}
                        registerInputRef={registerInputRef}
                        focusPartyInput={focusPartyInput}
                    />
                ),
            },
        ],
        [handleDetailChange, registerInputRef, focusPartyInput]
    );


    const SaveHandler = useCallback(async (event) => {
        event.preventDefault();
        try {
            if (formValid(state, setState)) {
                // Always one entry per party. Empty box -> Urls: null
                // (an override being cleared), never omitted.
                const erpUrlDetailsPayload = details
                    .filter((row) => (row.Urls || "").trim().length > 0)
                    .map((row) => ({
                        PartyId: row.partyId,
                        Urls: row.Urls.trim(),
                    }));

                const jsonBody = JSON.stringify({
                    Name: values.Name,
                    Urls: values.Urls,
                    PartyDetails: erpUrlDetailsPayload,
                });

                if (pageMode === mode.edit) {
                    dispatch(updateERPUrlID({ jsonBody, updateId: values.id }));
                } else {
                    console.log(jsonBody)
                    dispatch(saveERPUrlMaster({ jsonBody }));
                }
            }
        } catch (e) { CommonConsole(e) }
    }, [state, details, values, pageMode, dispatch]);


    if (!(userPageAccessState === '')) {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <MetaTags>{metaTagLabel(userPageAccessState)}</MetaTags>

                        <Card className="text-black">
                            <CardHeader className="card-header   text-black c_card_header" >
                                <h4 className="card-title text-black">{userPageAccessState.PageDescription}</h4>
                                <p className="card-title-desc text-black" dangerouslySetInnerHTML={{ __html: userPageAccessState.PageDescriptionDetails }} />
                            </CardHeader>

                            <CardBody className=" vh-10 0 text-black " >
                                <form noValidate>

                                    <Card>
                                        <CardBody className="c_card_body">
                                            <Row>
                                                <FormGroup className="mb-2 col col-sm-4 ">
                                                    <Label htmlFor="validationCustom01">{fieldLabel.Name} </Label>
                                                    <Input
                                                        name="Name"
                                                        id="txtName"
                                                        value={values.Name}
                                                        type="text"
                                                        disabled={pageMode === mode.edit}
                                                        className={isError.Name.length > 0 ? "is-invalid form-control" : "form-control"}
                                                        placeholder="Please Enter Name"
                                                        autoComplete='off'
                                                        autoFocus={true}
                                                        onChange={(event) => {
                                                            onChangeText({ event, state, setState })
                                                            dispatch(Breadcrumb_inputName(event.target.value))
                                                        }}
                                                    />
                                                    {isError.Name.length > 0 && (
                                                        <span className="invalid-feedback">{isError.Name}</span>
                                                    )}
                                                </FormGroup>

                                                <FormGroup className="mb-2 col col-sm-8 ">
                                                    <Label htmlFor="validationCustom01">{fieldLabel.Urls} </Label>
                                                    <Input
                                                        name="Urls"
                                                        id="txtUrls"
                                                        value={values.Urls}
                                                        type="text"
                                                        className={isError.Urls.length > 0 ? "is-invalid form-control" : "form-control"}
                                                        placeholder="Please Enter Url"
                                                        autoComplete='off'
                                                        onChange={(event) => {
                                                            onChangeText({ event, state, setState })
                                                            dispatch(Breadcrumb_inputName(event.target.value))
                                                        }}
                                                    />
                                                    {isError.Urls.length > 0 && (
                                                        <span className="invalid-feedback">{isError.Urls}</span>
                                                    )}
                                                </FormGroup>
                                            </Row>

                                            {/* ---------------------- Party-wise URL overrides ---------------------- */}
                                            {/* Fixed row per party — no add/remove. Clearing a box sends Urls: null. */}
                                            <Row>
                                                <FormGroup className="mb-2 col col-sm-12">
                                                    <Label>Party Wise Url</Label>

                                                    <ToolkitProvider
                                                        keyField="partyId"
                                                        data={details}
                                                        columns={partyUrlColumns}
                                                        search
                                                    >
                                                        {(toolkitProps) => (
                                                            <React.Fragment>
                                                                {globalTableSearchProps(toolkitProps.searchProps)}
                                                                <div style={{ maxHeight: "700px", overflowY: "auto", overflowX: "auto", border: "1px solid #dee2e6", }} >
                                                                    <BootstrapTable
                                                                        keyField="partyId"
                                                                        classes="custom-table"
                                                                        bordered
                                                                        condensed
                                                                        noDataIndication={
                                                                            <div className="text-danger text-center">
                                                                                No parties available.
                                                                            </div>
                                                                        }
                                                                        {...toolkitProps.baseProps}
                                                                    />
                                                                </div>
                                                            </React.Fragment>
                                                        )}
                                                    </ToolkitProvider>
                                                </FormGroup>
                                            </Row>

                                            <FormGroup className="mt-1">
                                                <Row>
                                                    <Col sm={2}>
                                                        <SaveButton
                                                            loading={saveBtnloading}
                                                            pageMode={pageMode}
                                                            onClick={SaveHandler}
                                                            userAcc={userPageAccessState}
                                                            editCreatedBy={editCreatedBy}
                                                            module={"ERPUrl"}
                                                        />
                                                    </Col>
                                                </Row>
                                            </FormGroup>
                                        </CardBody>
                                    </Card>
                                </form>
                            </CardBody>
                        </Card>
                    </Container>
                </div>
            </React.Fragment >
        );
    }
    else {
        return (
            <React.Fragment></React.Fragment>
        )
    }
};

export default ERPUrl;